import type { ResultOf } from '@horof/shared';
import { graphql } from '../gql';

/** What the reports page summarizes: today's reminders and the arrears. */
export const ReportsOverviewDocument = graphql(`
  query ReportsOverview {
    remindersDue {
      totalCount
    }
    arrearsList {
      nodes {
        amountDue
      }
    }
  }
`);

/** Members to remind today (arqam: settings' first reminder and interval). */
export const RemindersDueDocument = graphql(`
  query RemindersDue {
    remindersDue {
      nodes {
        memberId
        fullName
        kind
        amountDue
        billsCount
        oldestBillMonth
        daysOverdue
        lastRemindedAt
        remindersSent
        phoneStatus
        notifyChannel
        whatsappUrl
        whatsappMessage
        smsUrl
        smsMessage
        noticeLink
      }
    }
  }
`);

export const RecordReminderDocument = graphql(`
  mutation RecordReminder(
    $memberId: UUID!
    $channel: NotifyChannel!
    $message: String
  ) {
    appRecordReminder(
      input: { memberId: $memberId, channel: $channel, message: $message }
    ) {
      result {
        id
      }
    }
  }
`);

/** Every member who owes, most overdue first. */
export const ArrearsDocument = graphql(`
  query Arrears {
    arrearsList {
      nodes {
        memberId
        fullName
        amountDue
        billsCount
        oldestBillMonth
        daysOverdue
        publiclyListed
        phoneStatus
        notifyChannel
        noticeLink
      }
    }
  }
`);

export type Arrear = NonNullable<
  NonNullable<ResultOf<typeof ArrearsDocument>['arrearsList']>['nodes'][number]
>;
export type Reminder = NonNullable<
  NonNullable<
    ResultOf<typeof RemindersDueDocument>['remindersDue']
  >['nodes'][number]
>;
